import fs from 'node:fs/promises'
import path from 'node:path'
import { fileURLToPath } from 'node:url'
import as from 'ansis'
import type { Command } from 'commander'

import { output } from '@/helpers/std-out'
import { openBrowser } from '@/helpers/url-opener'

const __dirname = path.dirname(fileURLToPath(import.meta.url))

const fileExists = async (filePath: string) => {
  try {
    await fs.access(filePath)
    return true
  } catch {
    return false
  }
}

export function ServeReadmeCommand(cmd: Command) {
  cmd.description('Open documentation for the CLI')
  cmd.action(async () => {
    const docsPath = path.join(__dirname, 'docs.html')

    // When user runs the CLI from the source code, the docs file does not exist
    if ((await fileExists(docsPath)) === false) {
      return output
        .error()
        .title('Documentation not found')
        .message(
          'You can access documentation only by running the bundled version of the CLI.',
        )
        .exit('error')
    }

    const docsUrl = `file://${path.join(__dirname, 'docs.html')}`
    openBrowser(docsUrl)

    output
      .info()
      .message(
        'Documentation is being opened in your default browser. If it does not open automatically, please visit the following URL:',
      )
      .line(as.blue(docsUrl))
      .line()
      .exit('success')
  })

  return cmd
}
